// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__UtRG2","open":"style_open__dNdyH","panel":"style_panel__6YtoV","title":"style_title__rtLBw","steps":"style_steps__Ag4Qp","actions":"style_actions__2FCRO"};